<h1 mat-dialog-title>{{'Select displayed columns' | translate}}</h1>
<div mat-dialog-content>
  <div>
    <hr>
      <mat-checkbox (change)="onChangeSelectAll($event)" [checked]="false">
        {{'Select all' | translate}}
      </mat-checkbox>
      <hr>
      </div>
      <mat-selection-list (cdkDropListDropped)="drop($event)" cdkDropList>
        @for (c of data.columns; track c) {
          <mat-list-option (click)="onColumnChecked(c)" [selected]="c.selected" cdkDrag>
            {{c.description | async}}
          </mat-list-option>
        }
      </mat-selection-list>

    </div>
    <div mat-dialog-actions>
      <!-- <button mat-button [mat-dialog-close] cdkFocusInitial>Ok</button> -->
      <button (click)="save()" mat-button type="button">{{'Save' | translate}}</button>
      <span class="fill-space"></span>
      <button (click)="cancel()" mat-button type="button">{{'Cancel' | translate}}</button>
    </div>
